<template>
  <g>
    <path
      class="c1"
      d="M58.2727 3H11.7273C6.90733 3 3 6.90733 3 11.7273V58.2727C3 63.0927 6.90733 67 11.7273 67H58.2727C63.0927 67 67 63.0927 67 58.2727V11.7273C67 6.90733 63.0927 3 58.2727 3Z"
      :stroke="iconBorder"
      fill="transparent"
      stroke-width="5"
      stroke-linecap="round"
      stroke-linejoin="round"
    />
    <path
      class="c2"
      d="M21.9091 26.2729C24.3191 26.2729 26.2727 24.3193 26.2727 21.9093C26.2727 19.4993 24.3191 17.5457 21.9091 17.5457C19.4991 17.5457 17.5455 19.4993 17.5455 21.9093C17.5455 24.3193 19.4991 26.2729 21.9091 26.2729Z"
      :fill="iconColor"
    />
    <path
      class="c2"
      d="M35 39.3637C37.41 39.3637 39.3636 37.4101 39.3636 35.0001C39.3636 32.5901 37.41 30.6365 35 30.6365C32.59 30.6365 30.6364 32.5901 30.6364 35.0001C30.6364 37.4101 32.59 39.3637 35 39.3637Z"
      :fill="iconColor"
    />
    <path
      class="c2"
      d="M48.0909 52.4546C50.5009 52.4546 52.4545 50.5009 52.4545 48.0909C52.4545 45.681 50.5009 43.7273 48.0909 43.7273C45.6809 43.7273 43.7273 45.681 43.7273 48.0909C43.7273 50.5009 45.6809 52.4546 48.0909 52.4546Z"
      :fill="iconColor"
    />
  </g>
</template>

<script>
export default {
   props: {
    iconColor: {
      type: String,
      required: false,
      default: 'black',
    },
    iconBorder: {
      type: String,
      required: false,
      default: 'black',
    },
   },   
};
</script>

<style scoped>
    path {
        font-family: var(--iconFontFamily);
        font-size: var(--iconFontSize);        
    }

    .c2 {
      fill:var(--iconColor)
    }

    .c1 {
      stroke:var(--iconColor)
    }

    .group:hover .group-hover\:text-hoverIcon  .c2{
      fill:var(--iconHoberColor)
    }

    .group:hover .group-hover\:text-hoverIcon  .c1 {
      stroke:var(--iconHoberColor)
    }
</style>